
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 471 439.5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#7AC774","d":"M452.9 9.4C435.1-4.1 411.1-3 394.7 12.2l-.5.4-180.5 195.2c-32.4.6-59.5 11.8-80.5 33.5-12 12.4-20.2 27.4-26.1 39.2-6.9 13.9-13.1 28.1-19 41.8-3.2 7.5-6.5 14.9-9.8 22.4-11.2 24.7-23.7 41-40.6 52.6L0 422.4s37 14.9 80.6 17c5.9.3 11.8 0 17.6-.6 45.8-4.9 92-9.7 137.3-27.6 46.4-18.3 77.1-59.8 78.5-104.6v-1.8L465.1 67.6l.8-1.3c10.2-20 4.8-43.4-13-56.9zM220.7 381.6c-49.2 19.4-99.2 28.1-148.9 25.8 16.4-16.8 26.1-35.5 32.5-49.6 3.5-7.6 6.8-15.4 10-22.9 5.8-13.3 11.7-27.1 18.2-40.1 4.9-9.7 11.6-22 20.5-31.3 15.3-15.9 35.6-23.9 60.3-23.9h1c20.1.2 36 6.7 48.6 20 0 0 7.4 7.6 11.4 18.1 2 5.3 3.6 10.5 4.2 15.2 4.8 36.9-18.9 73.4-57.8 88.7zM437.8 51.2L305.2 259.4c-.5-1.3-.8-2.1-.8-2.1-12.1-27.8-52.3-43.8-52.3-43.8-.1 0-.1 0-.2-.1L416.6 35.3c7.6-6.6 14.9-2 17-.5 2.1 1.6 8.4 7.3 4.2 16.4z"}})])
          )
        }
      }
    